@use "@design/design-tokens/typography/typography" as *;
@use "@design/design-tokens/border-radius/border-radius" as *;

.root {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.sentimentLabel {
  @include typography-v2-ui-sm;
}

.headerWrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.headerActionWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.headerActionLeft {
  display: flex;
  align-items: center;
  gap: 8px;
}

.downloadButton,
.copyButton {
  padding: 2px 8px;
}

.watchlistButton {
  @include border-radius-r1;

  &.active {
    color: var(--text-success);
    border-color: var(--border-success);

    svg {
      fill: var(--icon-success);
    }
  }
}

.insightTypePillWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.insightTypePillGroup {
  display: flex;
  align-items: center;
  gap: 8px;
}

.metadataText {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--text-soft);

  @include typography-v2-body-sm;
}

.dot {
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background: var(--icon-soft);
  flex-shrink: 0;
}

.title {
  @include typography-v2-title-lg;
}
